<div class="side-container">
    <app-image-box [url]="logoPath$$()" [border]="false" />
</div>

@if (showForm$$()) {
    <form id="form" [formGroup]="Form" autocomplete="chrome-off" (keyup.enter)="register()">
        <h2>Registreer een nieuw account.</h2>
        @if (invitation$$(); as invitation) {
            <p class="invitation-banner">
                Je bent uitgenodigd voor <strong>{{invitation[invitationKeys.domain_Name]}}</strong>.
                Registreer met het uitgenodigde e-mailadres; na registratie en goedkeuring door
                de domeineigenaar krijg je toegang.
            </p>
        } @else if (invitationInvalid$$()) {
            <p class="invitation-banner invitation-banner--invalid">
                Deze uitnodigingslink is ongeldig of verlopen. Je kunt wel gewoon een account
                registreren; vraag daarna een nieuwe uitnodiging aan bij de domeineigenaar.
            </p>
        }
        <app-input-control [htmlAutocomplete]="'given-name'"
            [autofocus]="true"
            [control]="FormControls.firstName"
            [label]="'voornaam'"
            [lockOnLoad]="true"
            [placeholder]="'vul je voornaam in (optioneel)'"
            [showError]="showErrors || Form.touched"
            [tabIndex]="'0'"
            [type]="'text'" />
        <app-input-control [htmlAutocomplete]="'family-name'"
            [control]="FormControls.lastName"
            [label]="'achternaam'"
            [lockOnLoad]="true"
            [placeholder]="'vul je achternaam in (optioneel)'"
            [showError]="showErrors || Form.touched"
            [tabIndex]="'0'"
            [type]="'text'" />
        <app-input-control [htmlAutocomplete]="'off'"
            [control]="FormControls.applicationName"
            [label]="'naam in de applicatie'"
            [lockOnLoad]="true"
            [placeholder]="'zichtbaar voor anderen; leeg = voor- en achternaam, anders e-mailadres'"
            [showError]="showErrors || Form.touched"
            [tabIndex]="'0'"
            [type]="'text'" />
        <app-input-control [htmlAutocomplete]="'off'"
            [control]="FormControls.correspondenceName"
            [label]="'aanhef in e-mails'"
            [lockOnLoad]="true"
            [placeholder]="'bv. Jan of Dhr. J. Jansen; leeg = naam in de applicatie'"
            [showError]="showErrors || Form.touched"
            [tabIndex]="'0'"
            [type]="'text'" />
        <app-input-control [htmlAutocomplete]="'off'"
            [control]="FormControls.email"
            [label]="'email'"
            [lockOnLoad]="true"
            [placeholder]="'vul je e-mailadres in'"
            [showError]="showErrors || Form.touched"
            [tabIndex]="'0'"
            [type]="'email'" />
        <app-input-control
            [htmlAutocomplete]="'new-password'"
            [control]="FormControls.password"
            [label]="'wachtwoord'"
            [lockOnLoad]="false"
            [placeholder]="'minimaal 10 tekens, met een cijfer'"
            [showError]="showErrors || Form.touched"
            [tabIndex]="'0'"
            [type]="'password'" />
        <app-input-control
            [htmlAutocomplete]="'new-password'"
            [control]="FormControls.passwordRepeat"
            [label]="'wachtwoord (herhaal)'"
            [lockOnLoad]="false"
            [placeholder]="'herhaal je wachtwoord'"
            [showError]="showErrors || Form.touched"
            [tabIndex]="'0'"
            [type]="'password'" />
        @if ((showErrors || Form.touched) && FormControls.password.errors?.['minlength']) {
            <p class="form-error">Wachtwoord moet minimaal 10 tekens bevatten.</p>
        }
        @if ((showErrors || Form.touched) && FormControls.password.errors?.['pattern']) {
            <p class="form-error">Wachtwoord moet minimaal 1 cijfer bevatten.</p>
        }
        @if ((showErrors || Form.touched) && Form.errors?.['passwordMismatch']) {
            <p class="form-error">De wachtwoorden komen niet overeen.</p>
        }
        <div>
            <p class="my-1">
                <a routerLink="/login">Al een account? Log in</a>
            </p>
        </div>
    </form>
} @else {
    <div class="email-sent">
        <h2>Controleer je e-mail</h2>
        <p>
            We hebben een bevestigingslink gestuurd naar
            <strong>{{FormControls.email.value}}</strong>.
            Klik op de link in die mail om je account te activeren.
        </p>
        <p class="resend">
            Geen mail ontvangen? Controleer je spam-map of
            <a href="javascript:void(0)" (click)="resendConfirm()">verstuur de mail opnieuw</a>.
        </p>
    </div>
}

<ng-template #template_sectionDetails_extraButtons>
    @if (showForm$$()) {
        <app-button-action form="form"
            (btnClick)="register()"
            [loadKey]="loadKey"
            [lockOnLoad]="true"
        >registreer</app-button-action>
    } @else {
        <app-button-action
            (btnClick)="emit_gotoLogin()"
        >naar login</app-button-action>
    }
</ng-template>
